export const API_ENDPOINTS = {
  GET_DUPLICATE_CUSTOMER_SCENARIO: 'GetDuplicateCustomer',
  GET_DUPLICATE_CUSTOMER_TERMINAL: 'GetDuplicateCustomerForTerminal',
  MERGE_CUSTOMERS_SCENARIO: 'MergeCustomers',
  MERGE_CUSTOMERS_TERMINAL: 'MergeCustomerFromReport'
};

export const getDuplicateCustomerApiConfig = ({isTerminalLevel, terminalId, scenarioId}) => {
  if (isTerminalLevel) {
    return {
      endpoint: API_ENDPOINTS.GET_DUPLICATE_CUSTOMER_TERMINAL,
      queryString: `terminalId=${terminalId}`,
    };
  }
  return {
    endpoint: API_ENDPOINTS.GET_DUPLICATE_CUSTOMER_SCENARIO,
    queryString: `scenarioId=${scenarioId}`
  };
};

export const filterDuplicateCustomersByTrapRoute = (excludeTrapRoute, duplicateCustomerData) => {
  if (!excludeTrapRoute || !duplicateCustomerData) {
    return duplicateCustomerData || [];
  }

  const validGroupCount = {};
  const customersWithoutTrap = duplicateCustomerData.filter((customer) => !customer.isTrapRoute);

  const validGroupIds = customersWithoutTrap.reduce((groupIds, customer) => {
    validGroupCount[customer.groupId] = (validGroupCount[customer.groupId] || 0) + 1;
    if (validGroupCount[customer.groupId] > 1) {
      return [...groupIds, customer.groupId];
    }
    return groupIds;
  }, []);

  return customersWithoutTrap.filter((customer) => validGroupIds.includes(customer.groupId));
};

export const mapCustomerToMergeFormat = (customer, generateKey) => ({
  ...customer,
  routeName: customer.route,
  consigneeName: customer.customer,
  customerPreferredRouteName: '',
  consigneeId: customer.customerID,
  consigneeAddress: customer.address,
  key: generateKey()
});

export const hasSelectedTrapRouteCustomers = (selectedCustomers) => {
  return selectedCustomers.some((customer) => customer.isTrapRoute);
};

export const hasMultipleGroupIds = (selectedCustomers) => {
  const groupIds = [...new Set(selectedCustomers.map((customer) => customer.groupId))];
  return groupIds.length > 1;
};

